import React, { useState } from 'react';
import { Space, Typography, Input } from 'antd';
import "./css/TitleComponent.css";
import "../styles/App.css";

const { Title } = Typography;

const TitleComponent = ({ title, onChange, titleSize = "medium", titleEditable = false, iconPosition = 'left' }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editTitle, setEditTitle] = useState(title);

  const sizeMap = {
    "extrasmall": 4,
    "small": 3,
    "medium": 2,
    "large": 1
  };
  const size = sizeMap[titleSize.toLowerCase()] || sizeMap["medium"];

  const toggleEdit = () => {
    if (isEditing && onChange) {
      onChange(editTitle);
    }
    setIsEditing(!isEditing);
  };

  const handleInputChange = (e) => {
    setEditTitle(e.target.value);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && onChange) {
      onChange(editTitle);
      setIsEditing(false);
    } else if (e.key === 'Escape') {
      setEditTitle(title);
      setIsEditing(false);
    }
  };

  const handleClick = () => {
    if (titleEditable) {
      setEditTitle(title);
      setIsEditing(true);
    }
  };

  if(iconPosition === 'left')
  {
    return (
      <Space className="iconified-title" >
        {isEditing ? (
          <Input
            className="custom-title-input"
            value={editTitle}
            onChange={handleInputChange}
            onKeyDown={handleKeyDown}
            onBlur={toggleEdit}
            autoFocus
          />
        ) : (
          <Title level={size} className="custom-title iconified-title-text">{title}</Title>
        )}
      </Space>
    );
  } else
  {
    return (
      <Space className="iconified-title">
       
        {isEditing ? (
          <Input
            className="custom-title-input"
            value={editTitle}
            onChange={handleInputChange}
            onKeyDown={handleKeyDown}
            onBlur={toggleEdit}
            autoFocus
          />
        ) : (
          <Title level={size} className="custom-title iconified-title-text">{title}</Title>
        )}

      </Space>
    );
  }
 
};

export default TitleComponent;
